export function HolidayScorerIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 10l10 6 10-6v10l-10 6-10-6z" />
      <path d="M14 20v10l10 6 10-6V20" />
      <path d="M24 16v10" />
      <path d="M24 36v4" />
      <path d="M20 42h8" />
    </svg>
  );
}
